import { useQuery } from "react-query";
import ProductsService from "../api/services/ProductsService";

export const useProduct = (queryKey: string, id: string | null) =>
  useQuery(
    [queryKey, id],
    async () => await ProductsService.getProductById(id),
    {
      enabled: !!id,
      select({ data }) {
        return data?.product;
      },
    }
  );
